import PropTypes from 'prop-types';
const loanProposal = PropTypes.shape({
    term: PropTypes.number,
    totalLoan: PropTypes.number,
    totalPayment: PropTypes.number,
    totalInterest: PropTypes.number,
    approvedAmount: PropTypes.number,
    loanProposalId: PropTypes.string,
    totalPrincipal: PropTypes.number,
    totalGuarantee: PropTypes.number,
    totalInstallment: PropTypes.number,
    totalGuaranteeRate: PropTypes.number,
    effectiveAnnualRate: PropTypes.number,
    totalMonthlyPayment: PropTypes.number,
    effectiveMonthlyRate: PropTypes.number,
});
const tabLabels = PropTypes.shape({
    rateLabel: PropTypes.string,
    actionLabel: PropTypes.string,
    noticeLabel: PropTypes.string,
    totalPaymentLabel: PropTypes.string,
    warrantyValueLabel: PropTypes.string,
    totalInterestLabel: PropTypes.string,
    monthlyPaymentLabel: PropTypes.string,
    annualRateInitialsLabel: PropTypes.string,
    monthlyRateInitialsLabel: PropTypes.string,
});
export const ProposalTabsPropTypes = {
    /** Set text labels */
    labels: tabLabels.isRequired,
    /** Array of loan proposals */
    proposals: PropTypes.arrayOf(loanProposal),
    /** Iso currency format */
    iso: PropTypes.string,
    /** Callback action, return proposal on submit */
    onSubmit: PropTypes.func,
    /** Loading boolean for action button */
    isLoading: PropTypes.bool,
    /** Callback action, return proposal selected */
    onChange: PropTypes.func,
    /** Proposal ID for defailt tab selected */
    defaultSelected: PropTypes.string
};
export const ProposalTabsDefaultValues = {
    iso: 'COP'
};
//# sourceMappingURL=proposal-tabs.prop-types.js.map